import { render, staticRenderFns } from "./licenses.vue?vue&type=template&id=70c4d854&"
import script from "./licenses.vue?vue&type=script&lang=js&"
export * from "./licenses.vue?vue&type=script&lang=js&"
import style0 from "./licenses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports